<!-- eslint-disable -->
<template>
  <CommonPages id="terms" :class="['terms-page']" :titlePrefix="'Terms of Service'"
    :metaDescription="domainConfig?.['meta']?.des || 'Terms of Service and conditions of use'">
    <div class="privacy-full">
      <div class="privacy-full__container">
        <div class="privacy-full__content">
          <h1 class="privacy-full__title">Terms of Service</h1>
          <div class="privacy-full__body">
            <div class="privacy-section">
              <p class="privacy-section__text">
                Welcome to {{ domainConfig?.IAmURL }} (“we,” “our,” “us”or ""this website""), a
                website that uses artificial intelligence to assist users in generating baby names
                tailored to their preferences. By accessing or using our services, you (“you” or
                “user”) agree to be bound by these Terms of Service (“Terms”). Please read them
                carefully before using the website.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">1. Acceptance of Terms</h2>
              <p class="privacy-section__text">
                By accessing or using this website in any way, including visiting, browsing, or
                submitting information, you agree to be bound by and abide by these Terms and our
                Privacy Policy.
                <br /><br />
                If you do not agree to these Terms, please do not use our services.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">2. Description of Service</h2>
              <p class="privacy-section__text">
                We provide users with baby name suggestions powered by artificial intelligence.
                Users
                can input preferences such as gender, language, meaning, and cultural background to
                receive curated name recommendations.
                <br /><br />
                Our service is intended for personal, non-commercial use only.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">3. User Responsibilities</h2>
              <p class="privacy-section__text">You agree not to:</p>
              <ul class="privacy-section__list">
                <li>Use the site for any unlawful purpose or to solicit others to perform or
                  participate in unlawful acts;</li>
                <li>Interfere with or circumvent the security features of the site;</li>
                <li>Reproduce, duplicate, copy, sell, or exploit any portion of the service without
                  express written permission;</li>
                <li>Submit false or misleading information.</li>
              </ul>
              <p class="privacy-section__text">You are solely responsible for any data or content
                you
                input into the service.</p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">4. Intellectual Property</h2>
              <p class="privacy-section__text">
                All content, including but not limited to text, code, AI-generated results,
                graphics,
                logos, and interface design, is the property of us and protected by copyright,
                trademark, and other intellectual property laws.
                <br /><br />
                You may not reuse or distribute any part of the service without our written
                permission, except for personal and non-commercial use.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">5. AI-Generated Content Disclaimer</h2>
              <p class="privacy-section__text">
                The names and suggestions generated by our AI are for informational and
                entertainment
                purposes only. We do not guarantee the uniqueness, cultural appropriateness, or
                suitability of any name. You are solely responsible for verifying the accuracy,
                cultural sensitivity, or legal usability of any name you choose.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">6. Modifications to Service</h2>
              <p class="privacy-section__text">
                We reserve the right to modify, suspend, or discontinue the service (or any part
                thereof) at any time without notice or liability.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">7. Termination</h2>
              <p class="privacy-section__text">
                We may terminate or suspend your access to the site at our sole discretion, without
                prior notice, for conduct that we believe violates these Terms or is otherwise
                harmful
                to other users or the service.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">8. Limitation of Liability</h2>
              <p class="privacy-section__text">
                To the fullest extent permitted by law, we and our affiliates, partners, and service
                providers are not liable for any direct, indirect, incidental, or consequential
                damages arising from your use of the Site or reliance on any AI-generated content.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">9. Indemnification</h2>
              <p class="privacy-section__text">
                You agree to defend, indemnify, and hold harmless the Site and its affiliates from
                any
                claims, liabilities, damages, or expenses arising from your use of the Site or
                violation of these Terms.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">10. Changes to Terms</h2>
              <p class="privacy-section__text">
                We may update these Terms at any time. Continued use of the service after such
                changes
                constitutes acceptance of the new Terms. The latest version will always be available
                on this page.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'

import '@/css/common.scss';

export default {
  name: 'Terms',
  components: {
    CommonPages
  },
  mixins: [common, adMixin, adTrackingMixin],
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
    ]),
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Terms] Component activated`);
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Terms] Component mounted`);
    }
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Terms] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Terms] Component beforeDestroy`);
    }
  },
  methods: {

  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.privacy-full {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	width: 100%;
	// margin: 0 0 rem(88);
	padding-bottom: rem(88);
	background: #191919;

	&__container {
		width: 100%;
		position: relative;
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		padding: rem(88) rem(180);
		position: relative;
		z-index: 1;
	}

	&__title {
		color: #fff;
		font-size: rem(24);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: 0;
	}

	&__body {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		align-self: stretch;
	}
}

.privacy-section {
	display: flex;
	flex-direction: column;
	gap: rem(16);
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;
	align-self: stretch;

	&__title {
		color: #fff;
		font-size: rem(18);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: 0;
	}

	&__subtitle {
		color: #fff;
		font-size: rem(16);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: rem(8) 0;
	}

	&__text {
		color: #fff;
		text-align: left;
		font-size: rem(16);
		line-height: rem(28);
		font-weight: 400;
		margin: rem(8) 0;
	}

	&__link {
		color: #fff;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	&__list,
	&__numbered-list {
		color: #fff;
		padding-left: rem(24);
		margin: rem(8) 0;

		li {
			margin-bottom: rem(10);
			line-height: rem(28);
			font-size: rem(16);

			strong {
				color: #fff;
				font-weight: 500;
				display: block;
				margin-bottom: rem(4);
			}
		}
	}

	&__numbered-list {
		counter-reset: section;
		list-style-type: none;
		padding-left: 0;

		> li {
			margin-bottom: rem(24);
			padding-left: rem(24);
			position: relative;

			&:before {
				counter-increment: section;
				content: counter(section) '.';
				position: absolute;
				left: 0;
				color: #fff;
				font-weight: 500;
			}
		}
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.privacy-full {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.privacy-full {
		&__content {
			width: 100%;
			padding: rem(40) rem(16);
		}

		&__title {
			font-size: rem(20);
			line-height: rem(20);
		}
	}

	.privacy-section {
		&__title {
			font-size: rem(16);
			line-height: rem(20);
		}

		&__subtitle {
			font-size: rem(14);
			line-height: rem(20);
		}

		&__text {
			font-size: rem(14);
			line-height: rem(24);
		}

		&__list,
		&__numbered-list {
			li {
				font-size: rem(14);
				line-height: rem(24);
			}
		}
	}
}
</style> 